import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Container from "react-bootstrap/Container";
import { Suspense, lazy } from "react";
import Loading from "./components/Loading";
import Profile from "./pages/Profile";

// Lazy-loaded pages
const Home = lazy(() => import("./pages/Home"));
const MemberInfo = lazy(() => import("./pages/Member/Member"));
const MemberDetails = lazy(() => import("./pages/Member/MemberDetails"));
const DepositInfo = lazy(() => import("./pages/Deposit/Deposit"));
const DepositDetails = lazy(() => import("./pages/Deposit/DepositDetails"));
const Istavrity = lazy(() => import("./pages/Istavrity/Istavrity"));
const FamilyDetails = lazy(() => import("./pages/Istavrity/FamilyDetails"));
const SignUp = lazy(() => import("./pages/auth/SignUp"));
const SignIn = lazy(() => import("./pages/auth/SignIn"));
const ForgotPass = lazy(() => import("./pages/auth/ForgotPass"));
const AddFc = lazy(() => import("./pages/auth/AddFc"));
const AddSecKey = lazy(() => import("./pages/auth/AddSecKey"));
const ManageUsers = lazy(() => import("./pages/ManageUsers"));
const PublicRoute = lazy(() => import("./components/auth/PublicRoute"));
const PrivateRoute = lazy(() => import("./components/auth/PrivateRoute"));
const Error = lazy(() => import("./components/Error"));

function App() {
  return (
    <>
    <Suspense fallback={<Loading />}>
      <Container fluid>
        <Routes>
          {/* Public Routes */}
          <Route path="/create-account" element={<PublicRoute element={<SignUp />} />} />
          <Route path="/signin" element={<PublicRoute element={<SignIn />} />} />
          <Route path="/forgot-password" element={<PublicRoute element={<ForgotPass />} />} />
          {/* Private Routes */}
          <Route path="/" element={<PrivateRoute element={<Home />} />} />
          <Route path="/members/*" element={<PrivateRoute element={<MemberInfo />} />} />
          <Route path="/deposits/*" element={<PrivateRoute element={<DepositInfo />} />} />
          <Route path="/istavrity/*" element={<PrivateRoute element={<Istavrity />} />} />
          <Route path="/add-fc" element={<PrivateRoute element={<AddFc />} />} />
          <Route path="/add-security-key" element={<PrivateRoute element={<AddSecKey />} />} />
          <Route path="/manage-user" element={<PrivateRoute element={<ManageUsers />} />} />
          <Route path="/members/member/:id" element={<PrivateRoute element={<MemberDetails />} />} />
          <Route path="/deposits/member/:id" element={<PrivateRoute element={<DepositDetails />} />} />
          <Route path="/istavrity/family/:id" element={<PrivateRoute element={<FamilyDetails />} />} />
          <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
          {/* Catch All */}
          <Route path="*" element={<Error />} />
        </Routes>
      </Container>
      {/* Toast Notifications */}
      <Toaster
        position="top-center"
        toastOptions={{
          success: { style: { background: "#58b287", color: "#fff" }, iconTheme: { secondary: "#333", primary: "#08fc20" } },
          error: { style: { background: "#cc7a7a", color: "#fff" }, iconTheme: { secondary: "#fff", primary: "#fc0824" } },
          duration: 3000,
        }}
      />
    </Suspense>
    </>
  );
}

export default App;
